import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
// import VueLazyLoad from 'vue-lazyload';
// import Vconsole from "vconsole";
import h5Config from '../utils/h5Config';
import htmlConfig from '../utils/htmlConfig';
import urlConfig from './url';
import http from '../utils/http';
import axios from '../utils/use_axios';
import pbcFun from './assets/publicFun';
import 'element-ui/lib/theme-chalk/index.css';
import '../public/font-awesome-4.7.0/css/font-awesome.min.css';
import '../public/style/yh-color.css';
import '../public/style/yh-common.css';
import './style/main.css';
import './style/minidatepicker.css';
import { Mixins, isRoleType } from './mixin/mixinIndex';
import lrz from 'lrz';
import limitMoreClick from '../utils/limitMoreClick';
import VueJsonp from 'vue-jsonp';
import { GetTarg } from './utils/tool';
import Url from './url';
Vue.use(VueJsonp);
import VDistpicker from 'v-distpicker';
Vue.component('v-distpicker', VDistpicker);
// import VueQArt from 'vue-qart';
// new Vue({ components: { VueQArt } });
// let vConsole = new Vconsole();
import './permission.js';
import echarts from 'echarts'
Vue.prototype.$echarts = echarts;
Vue.prototype.pbcFun = pbcFun;
Vue.prototype.http = http;
Vue.prototype.urlConfig = urlConfig;
Vue.prototype.uploadURL = window.urlConfig.file.up;
Vue.prototype.imgUrl = window.urlConfig.imgUrl;
Vue.prototype.limitMoreClick = limitMoreClick;
Vue.prototype.GetTarg = GetTarg;
Vue.prototype.$axios = axios;

// 设置axios的默认请求地址
axios.defaults.baseURL = window.urlConfig.url;
// 设置h5 禁止页面缩放
h5Config.setMeta();
// 禁止页面缓存
h5Config.setMeta({
  'http-equiv': 'Cache-control',
  content: 'no-cache'
});
h5Config.setMeta({
  'http-equiv': 'Cache',
  content: 'no-cache'
});
h5Config.setMeta({
  'http-equiv': 'Pragma',
  content: 'no-cache'
});
// 混入常用工具函数
Vue.mixin(...Mixins);
Vue.mixin(...isRoleType);

//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive('real-img', async function(el, binding) {
  //指令名称为：real-img
  let imgURL = binding.value; //获取图片地址
  if (imgURL?.substr(0, 9) === 'http://61') {
    el.setAttribute('src', imgURL);
    return;
  }
  if (imgURL) {
    let exist = await imageIsExist(Url.file.show + imgURL);
    if (!exist) {
      el.setAttribute('src', Url.file.beforeShow + imgURL);
    }
  }
});
console.log('更新时间------------------', new Date())
let imageIsExist = function(url) {
  return new Promise(resolve => {
    var img = new Image();
    img.src = url;
    if (img.complete) {
      resolve(true);
      img = null;
    }

    img.onerror = function() {
      resolve(false);
      img = null;
    };
  });
};

// 设置页面的title名字
htmlConfig.setTitle('兰州科技大市场后台');
Vue.config.productionTip = false;
Vue.use(ElementUI);

// 全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false;
// 全局修改默认配置，按下ESC不能关闭弹窗
ElementUI.Dialog.props.closeOnPressEscape.default = false;

// Vue.use(VueLazyLoad, {
//   error: require('./assets/logo.png'),
//   loading: require('./assets/logo.png')
// })
// Vue.use(Swiper);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
